import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';

@Component({
  selector: 'app-index-pit11-info',
  templateUrl: './index-pit11-info.component.html',
  styleUrls: ['./index-pit11-info.component.scss'],
  standalone: false
})
export class IndexPit11InfoComponent implements OnInit {
  private authService = inject(AuthService);


  constructor() { }

  ngOnInit(): void {
  }

  async signin() {
    await this.authService.login();
  }
}
